export const DEFAULT_OPTIONS = {
  priorities: [
    { value: "red", label: { en: "Urgent / immediate action", es: "Urgente / accion inmediata", de: "Dringend / sofortige Aktion" }, emoji: "🔴" },
    { value: "orange", label: { en: "Active follow-up", es: "En seguimiento activo", de: "Aktive Nachverfolgung" }, emoji: "🟠" },
    { value: "yellow", label: { en: "Live lead, no clear date", es: "Lead vivo, sin fecha clara", de: "Aktiver Lead, kein klares Datum" }, emoji: "🟡" },
    { value: "purple", label: { en: "Strategic (medium term)", es: "Estrategico (mediano plazo)", de: "Strategisch (mittelfristig)" }, emoji: "🟣" },
    { value: "blue", label: { en: "IP Development (funding)", es: "Desarrollo IP (fondeo)", de: "IP-Entwicklung (Finanzierung)" }, emoji: "🔵" },
    { value: "gray", label: { en: "Incubation", es: "Incubacion", de: "Inkubation" }, emoji: "⚪" },
    { value: "gold", label: { en: "Cash Recovery", es: "Cash Recovery", de: "Geldrückgewinnung" }, emoji: "💰" },
  ],
  categories: [
    { value: "producción_video", label: { en: "Production / Video", es: "Producción / Video", de: "Produktion / Video" }, emoji: "🎥" },
    { value: "fotografía", label: { en: "Photography", es: "Fotografía", de: "Fotografie" }, emoji: "📸" },
    { value: "cursos", label: { en: "Courses", es: "Cursos", de: "Kurse" }, emoji: "🎓" },
    { value: "eventos_cine", label: { en: "Events / Film", es: "Eventos / Cine", de: "Events / Film" }, emoji: "🎤" },
    { value: "tech_apps", label: { en: "Tech / Apps", es: "Tech / Apps", de: "Tech / Apps" }, emoji: "💻" },
    { value: "desarrollo_ip", label: { en: "IP Development", es: "Desarrollo de IP", de: "IP-Entwicklung" }, emoji: "🧠" },
    { value: "venta_activos", label: { en: "Asset Sale (Cash Recovery)", es: "Venta de Activos (Cash Recovery)", de: "Vermögensverkauf" }, emoji: "💰" },
    { value: "venta_equipo_av", label: { en: "AV Equipment Sale", es: "Venta equipo AV", de: "AV-Geräteverkauf" }, emoji: "🎤" },
  ],
  probabilities: [
    { value: "alta", label: { en: "High probability", es: "Alta probabilidad", de: "Hohe Wahrscheinlichkeit" }, emoji: "🟢" },
    { value: "media", label: { en: "Medium", es: "Media", de: "Mittel" }, emoji: "🟡" },
    { value: "baja", label: { en: "Low / stalled", es: "Baja / detenido", de: "Niedrig / gestoppt" }, emoji: "🔴" },
    { value: "futuro", label: { en: "Future", es: "Futuro", de: "Zukunft" }, emoji: "⏳" },
  ],
  bottlenecks: [
    { value: "cliente", label: { en: "Client", es: "Cliente", de: "Kunde" } },
    { value: "info_pendiente", label: { en: "Pending info", es: "Info pendiente", de: "Ausstehende Info" } },
    { value: "cotización", label: { en: "Quote", es: "Cotización", de: "Angebot" } },
    { value: "decision_interna", label: { en: "Internal decision", es: "Decision interna", de: "Interne Entscheidung" } },
    { value: "dinero", label: { en: "Budget", es: "Dinero", de: "Budget" } },
  ],
  income_types: [
    { value: "servicio", label: { en: "Service", es: "Servicio", de: "Dienstleistung" } },
    { value: "producto", label: { en: "Product", es: "Producto", de: "Produkt" } },
    { value: "venta_activo", label: { en: "Asset sale", es: "Venta de activo", de: "Vermögensverkauf" } },
    { value: "ip_grant", label: { en: "IP / Grant", es: "IP / grant", de: "IP / Fördermittel" } },
  ],
  time_units: [
    { value: "hours", label: { en: "Hours", es: "Horas", de: "Stunden" } },
    { value: "days", label: { en: "Days", es: "Dias", de: "Tage" } },
    { value: "weeks", label: { en: "Weeks", es: "Semanas", de: "Wochen" } },
  ],
  statuses: [
    { value: "New", label: { en: "New", es: "Nuevo", de: "Neu" } },
    { value: "Contacted", label: { en: "Contacted", es: "Contactado", de: "Kontaktiert" } },
    { value: "Quoted", label: { en: "Quoted", es: "Cotizado", de: "Angeboten" } },
    { value: "Negotiation", label: { en: "Negotiation", es: "Negociación", de: "Verhandlung" } },
    { value: "Won", label: { en: "Won", es: "Ganado", de: "Gewonnen" } },
    { value: "Lost", label: { en: "Lost", es: "Perdido", de: "Verloren" } },
  ],
};

export const MEDIUMS = [
  { value: "phone", label: { en: "Phone Call", es: "Llamada", de: "Telefonanruf" } },
  { value: "whatsapp", label: { en: "WhatsApp", es: "WhatsApp", de: "WhatsApp" } },
  { value: "email", label: { en: "Email", es: "Email", de: "E-Mail" } },
  { value: "zoom", label: { en: "Zoom", es: "Zoom", de: "Zoom" } },
  { value: "in_person", label: { en: "In Person", es: "Reunion Presencial", de: "Persönliches Treffen" } },
];

export const MEDIUMS_MAP = {
  phone: { en: "Call", es: "Llamada", de: "Anruf" },
  whatsapp: { en: "WhatsApp", es: "WhatsApp", de: "WhatsApp" },
  email: { en: "Email", es: "Email", de: "E-Mail" },
  zoom: { en: "Zoom", es: "Zoom", de: "Zoom" },
  in_person: { en: "In Person", es: "Presencial", de: "Persönlich" },
};

export const CURRENCY_CONFIG = {
  USD: { symbol: "$", locale: "en-US", name: "US Dollar" },
  MXN: { symbol: "MX$", locale: "es-MX", name: "Mexican Peso" },
  EUR: { symbol: "\u20ac", locale: "de-DE", name: "Euro" },
};

export const VALID_CURRENCIES = Object.keys(CURRENCY_CONFIG);

export const formatCurrency = (v, currency = "MXN") => {
  const c = CURRENCY_CONFIG[currency] || CURRENCY_CONFIG.MXN;
  return new Intl.NumberFormat(c.locale, { style: "currency", currency, maximumFractionDigits: 0 }).format(v || 0);
};

export const formatCurrencyFull = (v, currency = "USD") => {
  const c = CURRENCY_CONFIG[currency] || CURRENCY_CONFIG.USD;
  return new Intl.NumberFormat(c.locale, { style: "currency", currency, maximumFractionDigits: 2 }).format(v || 0);
};

export const formatDate = (d, lang = "en") => {
  if (!d) return "-";
  const locMap = { en: "en-US", es: "es-MX", de: "de-DE" };
  try { return new Date(d).toLocaleDateString(locMap[lang] || "en-US", { day: "2-digit", month: "short" }); }
  catch { return d; }
};

/**
 * Helper: resolve a label object { en, es, de } or plain string to current language
 */
export const resolveLabel = (label, lang = "en") => {
  if (!label) return "";
  if (typeof label === "string") return label;
  return label[lang] || label.en || label.es || "";
};


export const SECTION_NAME_MAP = {
  development: { es: "DESARROLLO / CREATIVO", de: "ENTWICKLUNG / KREATIV" },
  pre_production: { es: "PRE PRODUCCION", de: "VORPRODUKTION" },
  talent: { es: "TALENTO", de: "TALENT" },
  location: { es: "LOCACIONES", de: "DREHORTE" },
  crew_production: { es: "CREW - PRODUCCION", de: "CREW - PRODUKTION" },
  crew_camera: { es: "CREW - DEPTO. DE CAMARA", de: "CREW - KAMERAABTEILUNG" },
  crew_grip_electric: { es: "CREW - GRIP & ELECTRICO", de: "CREW - GRIP & ELEKTRIK" },
  crew_sound: { es: "CREW - SONIDO", de: "CREW - TON" },
  crew_art: { es: "CREW - DEPTO. DE ARTE", de: "CREW - KUNSTABTEILUNG" },
  crew_photo: { es: "CREW - FOTOGRAFIA", de: "CREW - FOTOGRAFIE" },
  crew_drivers: { es: "CREW - CONDUCTORES", de: "CREW - FAHRER" },
  crew_post: { es: "CREW - POST PRODUCCION", de: "CREW - POSTPRODUKTION" },
  gear_cameras: { es: "EQUIPO - CAMARAS", de: "AUSRÜSTUNG - KAMERAS" },
  gear_lenses: { es: "EQUIPO - LENTES", de: "AUSRÜSTUNG - OBJEKTIVE" },
  gear_camera_support: { es: "EQUIPO - SOPORTE DE CAMARA", de: "AUSRÜSTUNG - KAMERASTÜTZEN" },
  gear_monitors: { es: "EQUIPO - MONITORES", de: "AUSRÜSTUNG - MONITORE" },
  gear_lighting: { es: "EQUIPO - ILUMINACION", de: "AUSRÜSTUNG - BELEUCHTUNG" },
  gear_grip: { es: "EQUIPO - GRIP", de: "AUSRÜSTUNG - GRIP" },
  gear_audio: { es: "EQUIPO - AUDIO", de: "AUSRÜSTUNG - AUDIO" },
  gear_data: { es: "DATA & DIT", de: "DATEN & DIT" },
  gear_generators: { es: "GENERADORES & ENERGIA", de: "GENERATOREN & STROM" },
  expendables: { es: "EXPENDABLES", de: "VERBRAUCHSMATERIAL" },
  transportation: { es: "TRANSPORTACION", de: "TRANSPORT" },
  catering: { es: "CATERING & CRAFT", de: "CATERING & VERPFLEGUNG" },
  lodging: { es: "HOSPEDAJE", de: "UNTERKUNFT" },
  insurance: { es: "SEGUROS", de: "VERSICHERUNG" },
  coordination: { es: "COORDINACION Y ADMIN.", de: "KOORDINATION & VERW." },
};

export const resolveSecName = (sec, language) => {
  if (language === "en") return sec.name;
  const fb = SECTION_NAME_MAP[sec.key];
  const field = language === "es" ? "name_es" : "name_de";
  return sec[field] || (fb && fb[language]) || sec.name;
};

/**
 * Generic field resolver for any document with _es/_de suffix convention.
 * resolveField(block.content, "heading", "es") → block.content.heading_es || block.content.heading
 * resolveField(item, "description", "de") → item.description_de || item.description
 */
export const resolveField = (obj, field, lang = "en") => {
  if (!obj || !field) return "";
  if (lang === "en") return obj[field] || "";
  const localized = obj[`${field}_${lang}`];
  if (localized && localized.trim()) return localized;
  return obj[field] || "";
};
